<template>
  <DsRadioGroup v-model="proxy" :class="$style.dsRadioGroup">
    <DsRadioButton
      v-if="!inputStore.versicherungsnehmer.isFirma"
      :value="FAHRERKREIS_TYP.NUR_VN"
    >
      nur der Versicherungsnehmer
    </DsRadioButton>
    <DsRadioButton :value="FAHRERKREIS_TYP.FESTGELEGT">
      festgelegt
    </DsRadioButton>
    <DsRadioButton :value="FAHRERKREIS_TYP.OFFEN"> offen </DsRadioButton>
  </DsRadioGroup>
</template>

<script lang="ts" setup>
import { DsRadioButton, DsRadioGroup } from '@demvsystems/design-components';
import { computed } from 'vue';

import { useInputStore } from '@/features/Sparten';
import { FAHRERKREIS_TYP } from '@/features/Sparten/shared/types';

interface Props {
  modelValue: string;
}

const props = defineProps<Props>();

const emit = defineEmits(['update:modelValue']);

const inputStore = useInputStore();

const proxy = computed({
  get: () => props.modelValue,
  set: (val) => emit('update:modelValue', val),
});
</script>

<style module>
.dsRadioGroup {
  font-size: 0.875rem;
}
</style>
